"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputType = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
var InputType;
(function (InputType) {
    InputType["TEXT_AREA"] = "TEXT_AREA";
    InputType["TEXT_FIELD"] = "TEXT_FIELD";
    InputType["SINGLE_SELECT"] = "SINGLE_SELECT";
    InputType["MULTI_SELECT"] = "MULTI_SELECT";
    InputType["CHECKBOX"] = "CHECKBOX";
    InputType["TextArea"] = "TEXT_AREA";
    InputType["TextField"] = "TEXT_FIELD";
    InputType["SingleSelect"] = "SINGLE_SELECT";
    InputType["MultiSelect"] = "MULTI_SELECT";
    InputType["Checkbox"] = "CHECKBOX";
})(InputType || (exports.InputType = InputType = {}));
